import React from 'react';

import cs from 'classnames';

import {ListMessage} from 'app/components/general/ListMessage';
import {DocHeaderStructure} from 'app/general/structures/DocHeader';
import {MainContentContainer} from 'app/general/structures/MainContentContainer';
import MetaContentTypeName from 'app/general/structures/MetaContentTypeName';
import {UserContentContainer} from 'app/general/structures/UserContentContainer';
import {ImagesCarousel} from 'app/general/widgets/ImagesCarousel';
import {usePolicyByHashid} from 'app/policies/api';
import {
  getContentFromPolicy,
  policyHasAnyContent,
} from 'app/policies/components/PolicyEditPage/utils';
import {ProcedureStepFiles} from 'app/procedures/components/ProcedureStepFiles';
import {DocumentTagsList} from 'app/tags/components/DocumentTagsList';
import {getPolicyName} from 'app/utils/fallbacks';
import {gt} from 'app/utils/i18n';
import {isRightToLeftWrapper} from 'app/utils/rtl';

import {useTemplate} from '../context';

export function TemplatePolicyDetail() {
  const template = useTemplate();
  const {data: policy} = usePolicyByHashid(template.document_hashid);
  const content = getContentFromPolicy(policy);

  if (policy == null || content == null) {
    return null;
  }

  const policyTitle =
    typeof content.name === 'string'
      ? getPolicyName(content, true)
      : content.name;

  return (
    <>
      <DocHeaderStructure
        thumbnail={policy.thumbnail}
        advancedContent={<MetaContentTypeName contentType={'policy'} />}
        tagsContent={<DocumentTagsList tags={policy.tags} />}
        titleContent={
          <h1
            className={cs('fr-view', {
              'right-to-left-text': isRightToLeftWrapper(content.name),
            })}
          >
            <UserContentContainer content={policyTitle} />
          </h1>
        }
      />
      <MainContentContainer>
        {policyHasAnyContent(content) ? (
          <div>
            <UserContentContainer content={content.content} />

            {content.videos.length > 0 || content.embeds.length > 0 ? (
              <div className="images">
                <ImagesCarousel
                  onClick={(e) => e.stopPropagation()}
                  images={[...content.videos, ...content.embeds]}
                />
              </div>
            ) : null}
            {content.files.length > 0 ? (
              <ProcedureStepFiles files={content.files} />
            ) : null}
          </div>
        ) : (
          <ListMessage>{gt('This policy has no content.')}</ListMessage>
        )}
      </MainContentContainer>
    </>
  );
}
